import React, { Component } from "react";
import { withRouter } from "react-router";
import { gql, graphql, compose } from "react-apollo";
import _ from "lodash";

import { LOGGED_IN_USER } from "../../pages/HomePage";
import FormPost from "../form-post/FormPost";
import Card from "../../views/Card";
import withAuthen from "../authenticate/withAuthen";

class CreatePostContainer extends Component {
  render() {
    return (
      <Card title="Create">
        <FormPost onSave={this.handlePost} />
      </Card>
    );
  }

  handlePost = async value => {
    try {
      const loggedInUser = this.props.loggedUserQuery.loggedInUser;
      // redirect if no user is logged in
      if (!loggedInUser) {
        console.warn("Only logged in users can create new posts");
        this.props.history.push("/");
        return;
      }

      const { description, imageId, isPrivate, sendTo, sendURL } = value;
      const authorId = loggedInUser.id;

      const result = await this.props.CreatePostMutation({
        variables: {
          description,
          imageId,
          authorId,
          isPrivate,
          sendTo,
          sendURL
        }
      });
      console.log("create success !! ")
      this.props.history.replace(
        `/edit/${_.get(result, "data.createPost.id")}`
      );
    } catch (error) {
      window.M.toast({html: "error: " + error.message})
      console.log(error.name);
      console.log(error.message);
      console.log(error.stack);
    }
  };
}

const CREATE_POST = gql`
  mutation CreatePost(
    $description: String!
    $imageId: String!
    $isPrivate: Boolean!
    $authorId: ID!
    $sendTo: String!
    $sendURL: String!
  ) {
    createPost(
      description: $description
      imageId: $imageId
      isPrivate: $isPrivate
      authorId: $authorId
      sendTo: $sendTo
      sendURL: $sendURL
    ) {
      id
    }
  }
`;

export default compose(
  withAuthen,
  graphql(CREATE_POST, { name: "CreatePostMutation" })
)(withRouter(CreatePostContainer));



// WEBPACK FOOTER //
// ./src/templates/create-post/CreatePostContainer.js